import { AlertCircle } from 'lucide-react';

export type InvitationErrorType = 'cancelled';

interface InvalidInvitationPageProps {
  type: InvitationErrorType;
}

export function InvalidInvitationPage({ type }: InvalidInvitationPageProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
          {/* Title */}
          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            Invalid Invitation Link
          </h2>

          {/* Description */}
          <p className="text-gray-500 text-sm mb-8 leading-relaxed">
            This invitation link is either expired or has already been used. Please request a new invitation if you still need access.
          </p>

          {/* Illustration */}
          <div className="relative">
            <div className="flex items-center justify-center">
              {/* Left decorative lines */}
              <div className="flex items-center gap-1 mr-4">
                <div className="w-8 h-0.5 bg-primary-200 rounded"></div>
                <div className="w-4 h-0.5 bg-primary-300 rounded"></div>
              </div>

              {/* Center icon with decorative dots */}
              <div className="relative">
                {/* Small decorative elements around icon */}
                <div className="absolute -top-2 -right-2 w-2 h-2 text-primary-400">
                  <svg viewBox="0 0 8 8" fill="currentColor">
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                </div>
                <div className="absolute -top-1 right-4 text-primary-300">
                  <svg viewBox="0 0 8 8" fill="currentColor" className="w-1.5 h-1.5">
                    <path d="M4 0L5 3L8 4L5 5L4 8L3 5L0 4L3 3Z" />
                  </svg>
                </div>
                <div className="absolute top-0 -left-3 text-primary-300">
                  <svg viewBox="0 0 8 8" fill="currentColor" className="w-1.5 h-1.5">
                    <path d="M4 0L5 3L8 4L5 5L4 8L3 5L0 4L3 3Z" />
                  </svg>
                </div>
                <div className="absolute -bottom-1 -right-3 w-1.5 h-1.5 text-primary-300">
                  <svg viewBox="0 0 8 8" fill="currentColor">
                    <circle cx="4" cy="4" r="2" />
                  </svg>
                </div>

                {/* Main icon circle */}
                <div className="w-16 h-16 rounded-full border-2 border-primary-200 flex items-center justify-center bg-white">
                  <AlertCircle className="w-7 h-7 text-primary-500" strokeWidth={1.5} />
                </div>
              </div>

              {/* Right decorative lines */}
              <div className="flex items-center gap-1 ml-4">
                <div className="w-4 h-0.5 bg-primary-300 rounded"></div>
                <div className="w-8 h-0.5 bg-primary-200 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvalidInvitationPage;
